import Icon, { IconTypes } from "shared/ui/icon";
import { concatClassnames } from "shared/utils/concatClassnames";
import { WhatsAppLinkButton } from "./WhatsAppButton";
const WhatsAppCard = () => {
  return (
    <section className="gg-px-0 sm:gg-px-7">
      <div
        className={concatClassnames(
          "gg-flex gg-h-[65px] gg-items-center gg-rounded-[3px] gg-px-4",
          "E1F0E4 gg-border-[1.5px] gg-border-[#E1F0E4] gg-bg-[#F0F8F1] gg-text-sm gg-text-green-900",
        )}
      >
        <Icon
          name={IconTypes.WHATSAPP}
          alt=""
          className="gg-mr-2.5 gg-h-6 gg-w-[21px]"
        />

        <div>
          <h5 className="gg-font-bold">Hulp nodig?</h5>
          <p className="">Wij zitten voor je klaar</p>
        </div>

        <WhatsAppLinkButton />
      </div>
    </section>
  );
};
export default WhatsAppCard;
